<template>
	<div
		class="md:px-5 px-4 py-5 gap-5 flex items-center w-full justify-between bg-gray-300"
	>
		<div class="flex gap-4 items-center">
			<InformationCircleIcon class="w-[26px] h-[26px] min-w-[26px]" />
			<p class="font-medium text-gray-900">
				{{ blok.text }}
			</p>
		</div>
		<button
			type="button"
			class="py-[10px] px-5 min-w-[120px] flex items-center gap-[5px] text-white text-[13px] bg-black"
			@click="openAccountOnDesktop"
		>
			{{ blok.button_text }}
			<UserIcon class="w-[19px] h-[19px]" />
		</button>
	</div>
</template>

<script setup lang="ts">
import { InformationCircleIcon, UserIcon } from "@heroicons/vue/24/outline";
import type { LoginBar } from "~/types/storyblok/storyblok";
import { inject } from "vue";
import { useRouter } from "nuxt/app";
import type { SharedModal } from "~/layers/base/components/Shared/SharedModal.vue";

interface Props {
	blok: LoginBar;
}
const { blok } = defineProps<Props>();

const { loadUser, userHasSession } = useLoadUser();
const router = useRouter();
const localePath = useLocalePath();

const modal = inject<SharedModal>("modal") as SharedModal;

const openAccountOnDesktop = async () => {
	if (!(await userHasSession())) {
		modal.open("AccountLoginForm", {
			position: "side"
		});
	} else {
		await loadUser();
		router.push(localePath("/account"));
	}
};
</script>
